/** Widget feedback : instance partagée entre FeedbackWidget, qui l'initialise,
 * et les écrans qui l'ouvrent (Profil, sur mobile). */

import { useSyncExternalStore } from "react";

// Ce que Chronos appelle sur l'instance renvoyée par init. open() existe au
// runtime même là où le widget la déclare privée (TypeScript seulement) ;
// setTriggerVisible n'arrive qu'avec showTrigger (nesit-os-360#2057).
export interface NesitFeedbackPanel {
  open: () => void;
  setTriggerVisible?: (visible: boolean) => void;
}

let panel: NesitFeedbackPanel | null = null;
// Sur mobile, le bouton flottant recouvre la barre d'onglets : l'entrée passe
// par le Profil. Retenu ici pour s'appliquer dès l'init du widget.
let triggerVisible = true;
const listeners = new Set<() => void>();

export function feedbackTriggerVisible(): boolean {
  return triggerVisible;
}

export function registerFeedbackPanel(p: NesitFeedbackPanel): void {
  panel = p;
  for (const listener of listeners) listener();
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** Vrai une fois le widget initialisé. Avant, ou s'il n'a pas chargé, ouvrir
 * le panneau ne fait rien : l'entrée qui y mène ne doit pas s'afficher. */
export function useFeedbackReady(): boolean {
  return useSyncExternalStore(subscribe, () => panel !== null);
}

export function setFeedbackTrigger(visible: boolean): void {
  triggerVisible = visible;
  // Widget antérieur : pas de méthode, le bouton flottant reste affiché.
  if (panel && typeof panel.setTriggerVisible === "function") {
    panel.setTriggerVisible(visible);
  }
}

export function openFeedback(): void {
  panel?.open();
}
